"use client";

import { c as _c } from "react/compiler-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { cn } from "../../../../shared/utils/cn.js";
import { AnimatePresence, motion } from "motion/react";
import { Children, useEffect, useState } from "react";
export function TextLoop(t0) {
  const $ = _c(3);
  const {
    children,
    className,
    interval: t1,
    transition: t2,
    variants,
    onIndexChange
  } = t0;
  const interval = t1 === undefined ? 2 : t1;
  let t3;
  if ($[0] !== t2) {
    t3 = t2 === undefined ? {
      duration: 0.3
    } : t2;
    $[0] = t2;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const transition = t3;
  const [currentIndex, setCurrentIndex] = useState(0);
  const items = Children.toArray(children);
  useEffect(() => {
    const intervalMs = interval * 1000;
    const timer = setInterval(() => {
      setCurrentIndex(current => {
        const next = (current + 1) % items.length;
        onIndexChange?.(next);
        return next;
      });
    }, intervalMs);
    return () => clearInterval(timer);
  }, [items.length, interval, onIndexChange]);
  let t4;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      initial: {
        y: 20,
        opacity: 0
      },
      animate: {
        y: 0,
        opacity: 1
      },
      exit: {
        y: -20,
        opacity: 0
      }
    };
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  const motionVariants = t4;
  return _jsx("div", {
    className: cn("relative inline-block whitespace-nowrap", className),
    children: _jsx(AnimatePresence, {
      mode: "popLayout",
      initial: false,
      children: _jsx(motion.div, {
        initial: "initial",
        animate: "animate",
        exit: "exit",
        transition,
        variants: variants || motionVariants,
        children: items[currentIndex]
      }, currentIndex)
    })
  });
}